
export const navigation = {
  'nav.home': 'Home',
  'nav.profile': 'Profile',
  'nav.settings': 'Settings',
  'nav.logout': 'Logout',
  'errors.pageNotFound': 'Oops! The page you\'re looking for doesn\'t exist.',
  'nav.searchSubsidies': 'Search Subsidies',
  'nav.calendar': 'Calendar',
  'nav.regulations': 'Regulations',
  'nav.backToOverview': 'Back to Overview',
  'navigation.dashboard': 'Dashboard',
  'navigation.findFunding': 'Find Funding',
  'navigation.profile': 'Profile',
  'navigation.settings': 'Settings',
  'navigation.signIn': 'Sign In',
  'navigation.signUp': 'Sign Up',
  'navigation.signOut': 'Sign Out',
  'navigation.language': 'Language',
  'navigation.english': 'English',
  'navigation.french': 'Français',
  'navigation.aiAssistant': 'AI Assistant',
  'navigation.shortcuts': 'Shortcuts',
  'navigation.dispositifs': 'Programs',
} as const;
